
import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import VueI18n from 'vue-i18n';

@Component({
  name: 'catalog-product-specifications',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  @Prop() private productData: Array<object>;

  private get selectedProductSpecs(): Array<object> {
    const selectedProduct = this.$store.state['ProductView']['selectedProduct'];

    if (selectedProduct['specifications'] === undefined) {
      return this.productData;
    } else {
      return JSON.parse(selectedProduct['specifications']);
    }
  }
}
